import { makeStyles } from "@mui/styles";
import { Avatar, buttonClasses, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { FontProxima, v2theme } from "../../../styles/Theme";
import { useEffect, useRef, useState } from "react";

const useStyles = makeStyles((theme) => ({
  selectedFilterButton: {
    color: theme.palette.text.primary,
    borderRadius: "15px",
    "&:hover": {
      border: `2px solid ${v2theme.palette.primary.main}`,
      color: theme.palette.text.primary,
      transform: "none",
    },
  },
  closeButton: {
    color: "#DEDEDE",
  },
  closeButtonHover: {
    color: "#E74973",
  },
}));

interface CustomChipProps {
  label: string | undefined;
  onClose?: (e: any) => void;
  showAvatar?: boolean;
}

export const CustomChip = (props: CustomChipProps) => {
  const classes = useStyles();
  let { label, onClose, showAvatar = false } = props;
  const [hoverCloseIcon, setHoverCloseIcon] = useState(false);

  const [isOverflowed, setIsOverflow] = useState(false);
  const textElementRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    // @ts-ignore
    setIsOverflow(
      // @ts-ignore-next-line
      textElementRef?.current.scrollWidth > textElementRef?.current.clientWidth
    );
  }, []);

  return (
    <Tooltip
      arrow={true}
      title={label!}
      placement="bottom"
      disableHoverListener={!isOverflowed}>
      <Button
        tabIndex={-1}
        component="div"
        onMouseEnter={() => {
          setHoverCloseIcon(true);
        }}
        onMouseLeave={() => {
          setHoverCloseIcon(false);
        }}
        sx={{
          "&:hover": {
            backgroundColor: "#ffffff",
          },
          [`.${buttonClasses.endIcon}`]: {
            color: hoverCloseIcon ? "#E74973" : "#DEDEDE",
          },
        }}
        size="small"
        variant="outlined"
        className={classes.selectedFilterButton}
        endIcon={
          onClose ? (
            <CloseIcon
              tabIndex={0}
              className={hoverCloseIcon ? classes.closeButtonHover : classes.closeButton}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if (onClose) {
                  onClose(e);
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.stopPropagation();
                  e.preventDefault();
                  if (onClose) {
                    onClose(e);
                  }
                }
              }}
            />
          ) : undefined
        }>
        {showAvatar && label && (
          <Avatar
            sx={{
              backgroundColor: "#E2F7FF",
              height: "20px",
              width: "20px",
              marginRight: "4px",
            }}>
            <Typography
              component="span"
              variant="body2"
              sx={{ fontWeight: "500", fontSize: "0.5em", fontFamily: FontProxima }}>
              {label[0] + label[label.indexOf(" ") + 1]}
            </Typography>
          </Avatar>
        )}
        <Typography
          variant="body1"
          ref={textElementRef}
          sx={{
            maxWidth: "200px",
            fontWeight: "600",
            fontSize: "14px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}>
          {label}
        </Typography>
      </Button>
    </Tooltip>
  );
};
